module.exports = __webpack_public_path__ + "static/media/grad.80e4a1ee.JPG";